import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=1126f6c8&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=1126f6c8&prod&scoped=true&lang=css"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=1126f6c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1126f6c8",
  null
  
)

export default component.exports